import { Component, OnInit, ViewChild, Output, EventEmitter } from '@angular/core';
import { MatPaginator, MatPaginatorIntl } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { Subscription } from 'rxjs';
import { DataService } from '../service/data.service';
import { MatDialog, MatSnackBar } from '@angular/material';
import { BottomSheetComponent } from '../table-list/bottom-sheet/bottom-sheet.component';
import { DialogueComponent } from './dialogue/dialogue.component';
import { Config } from '../config/param';
import { TableListeService } from '../service/tableListe.service';
import { ParamDiversService } from '../service/paramDivers.service';
import { DialogueRelationComponent } from './dialogue-relation/dialogue-relation.component';
import localeFr from '@angular/common/locales/fr';
import { registerLocaleData } from '@angular/common';
registerLocaleData(localeFr);

@Component({
  selector: 'app-table-list',
  styleUrls: ['table-list.component.scss'],
  templateUrl: 'table-list.component.html'
})
export class TableListComponent implements OnInit {
  @Output() messageEvent = new EventEmitter<any>();
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

  public displayedColumns: string[] = ['dateTexte', 'texte', 'note'];
  public types;
  private querySubscription: Subscription;
  private allList: any;
  private list: any;

  public dataSource: MatTableDataSource<any> = new MatTableDataSource<any>();

  constructor(
    public dialog: MatDialog,
    public tableListService: TableListeService,
    public paramDiversService: ParamDiversService,
    private matPaginatorIntl: MatPaginatorIntl,
    public dataService: DataService,
    private snackBar: MatSnackBar
  ) { }

  openDialogRelation(element): void {
    this.tableListService.getRelationList(element.thesaurus_id).toPromise().then((res: any) => {
      const dialogRef = this.dialog.open(DialogueRelationComponent, {
        width: '450px',
        data: {
          element: res,
          types: this.types,
          list: this.list,
          dataElement: element
        },
      });
      dialogRef.afterClosed().subscribe(result => {
        // if (result) {
        //   const index = result.indexElement + 1;
        //   const search = result.indexSearchElement;
        //   const el = result.element;
        //   for (let i = 0; i < this.list.length; i++) {
        //     if (this.list[i].thesaurus_id === el.thesaurus_id) {
        //       this.list.splice(i, 1);
        //       break;
        //     }
        //   }
        //   this.list.splice(index, 0, this.allList[search]);
        //   this.initTable(this.list);
        // }

        // if thesaurus selected is in current list
        // remove this and move after the current thesaurus
        if (result.contain) {
          const selected = this.list[result.data.index];
          this.list.splice(result.data.index, 1);
          this.list.splice(result.data.currentIndex + 1, 0, selected);
        } else {
          this.list.splice(result.data.currentIndex + 1 , 0, result.data.thesaurus);
        }
        this.initTable(this.list);
      });
    })
  }

  downloadAnnexe(annexe: string) {
    if (annexe) {
      document.location.href = `${Config.API_URL}/download/annexe?filename=${annexe}`;
      this.snackBar.open('Téléchargement lancé', '', { duration: 2000 });
    }
  }

  openDialog(element): void {
    $('nav').slideUp('fast');
    const dialogRef = this.dialog.open(DialogueComponent, {
      width: '700px',
      maxHeight: '90vh',
      data: {
        date: element.thesaurus_date_texte,
        type: element.type,
        numText: element.thesaurus_num_texte,
        object: element.thesaurus_objet,
        etat: element.etat,
        note: element.thesaurus_note,
        ministeres: element.thesaurus_ministeres,
        sources: element.thesaurus_sources,
      },
    });
    dialogRef.afterClosed().subscribe(result => {
      $('nav').slideDown('fast');
      // console.log('The dialog was closed');
    });
  }

  openPDF(id): void {
    $('nav').slideUp('fast');
    let pdf;
    this.tableListService.getPdfContentById(id).toPromise().then((res: any) => {
      pdf = this.replaceBalise(res.thesaurus_texte);
      const dialogRef = this.dialog.open(BottomSheetComponent, {
        autoFocus: false,
        maxHeight: '98vh',
        data: { pdf }
      });

      dialogRef.afterClosed().subscribe(result => {
        $('nav').slideDown('false');
      });
    });
  }

  replaceBalise(element) {
    let tmp = element.split('<p>');
    element = tmp.join('<div class="new_p">');
    tmp = element.split('</p>');
    element = tmp.join('</div>');
    return element;
  }

  initPaginator() {
    this.dataSource.paginator = this.paginator;
    this.matPaginatorIntl.itemsPerPageLabel = 'Élément par page';
    this.matPaginatorIntl.firstPageLabel = 'Première page';
    this.matPaginatorIntl.lastPageLabel = 'Dernière page';
    this.matPaginatorIntl.nextPageLabel = 'Suivant';
    this.matPaginatorIntl.previousPageLabel = 'Précedent';
  }

  initTable(list: any) {
    this.dataSource = new MatTableDataSource<any>(list);
    this.dataSource.paginator = this.paginator;
    this.initPaginator();
  }

  ngOnInit() {
    this.paramDiversService.getParamByTable('categorie').subscribe((res: any) => { this.types = res; });
    // this.tableListService.getList().subscribe((res: any) => {
    //   for (const element of res) {
    //     element.etat = element.etat.param_description;
    //     element.type = element.type.param_description;
    //     element.thesaurus_objet = this.replaceBalise(element.thesaurus_objet);
    //     element.thesaurus_note = this.replaceBalise(element.thesaurus_note);
    //     element.num_relations = element.num_relations.length > 0;
    //   }
    //   this.allList = res;
    // });
    this.querySubscription = this.dataService.getEmittedValue().subscribe(res => {
      if (JSON.stringify(res) === '{}') {
        this.dataService.setMessage('Aucun résultat trouvé');
      } else {
        console.log('tete');
        this.list = res;
        this.initTable(res);
        this.dataService.setMessage('Résultat(s) de la recherche');
      }
      // console.log(res);
    });
  }
}
